import { render, staticRenderFns } from "./study-participant-edc-unscheduled-forms.vue?vue&type=template&id=270c15a2&scoped=true&"
import script from "./study-participant-edc-unscheduled-forms.vue?vue&type=script&lang=js&"
export * from "./study-participant-edc-unscheduled-forms.vue?vue&type=script&lang=js&"
import style0 from "./study-participant-edc-unscheduled-forms.vue?vue&type=style&index=0&id=270c15a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270c15a2",
  null
  
)

component.options.__file = "study-participant-edc-unscheduled-forms.vue"
export default component.exports